<h2 i18n="@@titleHistory">History</h2>

@if (chargersLoaded()) {
	@if (chargers().length > 0) {
		<mat-form-field appearance="outline" style="width: 250px; margin-right: 6px;">
			<mat-label i18n="@@SelectChargers">Select chargers</mat-label>
			<mat-select [value]="chargersSelected()" (valueChange)="chargersSelected.set($event)" multiple>
				@for (charger of chargers(); track charger.serialNumber) {
					<mat-option [value]="charger">{{charger.serialNumber}}</mat-option>
				}
			</mat-select>
		</mat-form-field>
		<br/>
		<mat-form-field appearance="outline" style="margin-right: 6px;">
			<mat-label i18n="@@DateRange">Enter a date range</mat-label>
			<mat-date-range-input 
				[rangePicker]="picker"
			>
				<input matStartDate placeholder="Start date" i18n-placeholder="@@StartDate" [value]="dateBegin()" (dateChange)="dateBegin.set($event.value)">
				<input matEndDate placeholder="End date" i18n-placeholder="@@EndDate" [value]="dateEnd()" (dateChange)="dateEnd.set($event.value)">
			</mat-date-range-input>
			<mat-hint i18n="@@DateFormat">MM/DD/YYYY - MM/DD/YYYY</mat-hint>
			<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
		</mat-form-field>
		<button matButton="elevated" (click)="setDateRange('lday')" style="margin-left: 16px;" i18n="@@LastDay">Last day</button>
		<button matButton="elevated" (click)="setDateRange('lweek')" style="margin-left: 16px;" i18n="@@LastWeek">Last week</button>
		<button matButton="elevated" (click)="setDateRange('lmonth')" style="margin-left: 16px;" i18n="@@LastMonth">Last month</button>
		<br/>
		<br/>
		<button matButton="elevated" color="primary"
			(click)="downloadCsv()"
			[disabled]="!chargeSessionHistory().length"
		>
			<mat-icon>download</mat-icon>
			<span i18n="@@Download">Download</span>
		</button>

		<br/>
		<br/>

		<div class="scroll-container" tabindex="0">
		@if (chargeSessionHistoryLoaded()) {
			<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
				<ng-container matColumnDef="chargerSerialNumber">
					<th mat-header-cell *matHeaderCellDef i18n="@@PNumber">P-Number</th>
					<td mat-cell *matCellDef="let element"> {{element.chargerSerialNumber}} </td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>

				<ng-container matColumnDef="begin">
					<th mat-header-cell *matHeaderCellDef i18n="@@BeginTime">Begin Time</th>
					<td mat-cell *matCellDef="let element"> {{element.begin.time * 1000 | date : 'medium'}} </td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>

				<ng-container matColumnDef="end">
					<th mat-header-cell *matHeaderCellDef i18n="@@EndTime">End Time</th>
					<td mat-cell *matCellDef="let element"> {{element.end.time * 1000 | date : 'medium'}}</td>
					<td mat-footer-cell *matFooterCellDef></td>
				</ng-container>

				<ng-container matColumnDef="totalChargingEnergy">
					<th mat-header-cell *matHeaderCellDef><span i18n="@@TotalChargingEnergy">Total Charging Energy</span> [kWh]</th>
					<td mat-cell *matCellDef="let element"> {{(element.totalChargingEnergy / 1000) | number:'1.1-1'}} </td>
					<td mat-footer-cell *matFooterCellDef><b> {{ (totalEnergy() / 1000) | number:'1.1-1' }} </b></td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
				<tr mat-footer-row *matFooterRowDef="displayedColumns sticky: false"></tr>
			</table>
		} 
		@else {
			<mat-spinner />
		}
			<mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
		</div>
	} @else {
		<span i18n="@@NoChargersAvailable">No chargers available!</span><br/><br/>
	}
} @else {
	<mat-spinner />
}
